import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './reducers'

// 白标部署（如 production2）置空 favicon：href 用 data:, 表示空图标，
// 同时可阻止浏览器回退请求默认的 /favicon.ico
if (process.env.REACT_APP_SHOW_FAVICON === 'false') {
  document.querySelectorAll("link[rel~='icon']").forEach(link => {
    link.setAttribute('href', 'data:,')
  })
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
